/** The red Remove on quote cart lines: trash-and-label by default, or the trash icon alone */
export default function RemoveLineButton({
  onClick,
  label,
  iconOnly = false,
}: {
  onClick: () => void
  label: string
  iconOnly?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={iconOnly ? 'Remove' : undefined}
      className={
        iconOnly
          ? '-mr-2 -mt-1.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-red-600 transition-colors hover:bg-red-50 hover:text-red-700'
          : '-my-1 inline-flex items-center gap-1 rounded px-1 py-1 text-sm text-red-600 transition-colors hover:text-red-700'
      }>
      <svg
        aria-hidden="true"
        className="h-4 w-4"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 7h16M10 11v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
        />
      </svg>
      {!iconOnly && 'Remove'}
    </button>
  )
}
